var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLockOpen = function SvgIconLockOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.539 3.046a2.375 2.375 0 0 0-3.914 1.823V7.25H19.5c.966 0 1.75.784 1.75 1.75v10.5a1.75 1.75 0 0 1-1.75 1.75h-15a1.75 1.75 0 0 1-1.75-1.75V9c0-.966.784-1.75 1.75-1.75h3.125V4.878a4.375 4.375 0 0 1 8.726-.483 1 1 0 0 1-1.99.21 2.38 2.38 0 0 0-.822-1.56M8.625 9.25H4.75v10h14.5v-10H8.626",
    clipRule: "evenodd"
  }))));
};
export default SvgIconLockOpen;